__turbopack_context__.v({
  "customColorPicker": "HexColorPicker-module__Nf8dya__customColorPicker",
});
